// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__VhJFA","AddNew":"styles_AddNew__r7DzG","CommentButton":"styles_CommentButton__bFe0F","CommentButton__text":"styles_CommentButton__text__dakIl"};